import { Currency } from '@seapoint/server/enums';
import { Info } from 'lucide-react';
import { Inline } from '../../../../design-system/inline/inline';
import { getAmountWithCurrency } from '../../../../utils/get-amount-with-currency';
import { getPaidDateCellContent } from '../invoice-data-section/paid-invoice-table-columns-definition';

type InvoiceDrawerLastPaidCardProps = {
  lastPaidDate: Date;
  amount: number;
  currency: Currency;
};

export const InvoiceDrawerLastPaidCard = (props: InvoiceDrawerLastPaidCardProps) => {
  const { formattedDate, formattedAmount } = getCardContent(props);

  return (
    <Inline space={1.5}>
      <div className="h-4 w-4 rounded-full text-black">
        <Info className="h-full w-full" />
      </div>

      <p className="text-sm font-normal leading-6 tracking-tight text-seapoint-gray-text">
        Last paid <span className="text-black">{formattedDate}</span> {formattedAmount}
      </p>
    </Inline>
  );
};

const getCardContent = (props: InvoiceDrawerLastPaidCardProps) => {
  const { lastPaidDate, amount, currency } = props;

  const formattedDate = getPaidDateCellContent(lastPaidDate);
  const formattedAmount = getAmountWithCurrency({ amount, currency, isAccountBalance: true });

  return { formattedDate, formattedAmount };
};
